import { CommonHelper } from '../../../../helpers/common-helper'
import { EventsNames } from '../../../../helpers/events-names'
import { LocalizationHelper } from '../../../../helpers/localization-helper'
import { PopupType } from '../../../../helpers/popup-manager'

import { Enums } from '../../../../models/common/enums'
import { OpPackage, OpDepositoryElement } from '../../../../models/core'
import { IOpObject } from '../../../../models/util/interfaces'

import { OrderService } from '../../../../services/order'

import { CommonCreateEdit, CreateEditSection } from '../../../common/common.create-edit'
import { CreateEditInitParams, BulkEditInitParams } from '../../../common/create-edit-popup/create-edit-popup.controller'
import { CreateEditScope, CreateEditController } from '../../../common/common.create-edit.controller'

import { IAddOrder, AddOrderOptions } from '../add-order'

interface OrderCreateEditScope extends CreateEditScope { }

export class OrderCreateEditController extends CreateEditController {

    //#region Consts

    public get ADD_ORDER_CUSTOM_CREATE_EDIT_SECTION(): string { return 'ADD_ORDER_CUSTOM_CREATE_EDIT_SECTION' }

    //#endregion


    //#region Members

    private order: OpPackage
    private ordersAddOrder: IAddOrder
    public addOrderOptions: AddOrderOptions

    //#endregion


    //#region Ctor

    constructor(
        private $scope: OrderCreateEditScope,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private orderService: OrderService,
        protected referenceType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super(referenceType)

        this.setEvents()
        this.setOptions()
    }

    //#endregion


    //#region Events

    private onInit(args: any[]) {
        if (args && args[0]) {
            const createEditInitParams: CreateEditInitParams = args[0]
            this.order = createEditInitParams ? <OpPackage>createEditInitParams.referenceObject : null
            this.addOrderOptions = null

            createEditInitParams.sections.push(this.getArticlesCustomSection())

            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.CREATE_EDIT_POPUP)

            if (this.order && this.order.idObject > 0) {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDITING, this.moduleName)
            } else {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ADDING, this.moduleName)

                createEditInitParams.customDataSourcesDefaultValues = {}
                createEditInitParams.customDataSourcesDefaultValues[Enums.DataType.HELPER_ID_PACKAGE_STATUS] = Enums.PackageStatus.NewOrder
            }

            this.$timeout(() => {
                this.$scope.$broadcast(EventsNames.OPEN_CREATE_EDIT_POPUP, createEditInitParams)
            })
        }
    }

    private onInitBulk(args: any[]) {
        if (args && args[0]) {
            const bulkEditInitParams: BulkEditInitParams = args[0]

            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.BULK_EDIT_POPUP)

            this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__MASS_EDITING, this.moduleName)

            if (args && args[0]) {
                this.$scope.gridData = args[0]
            }

            if (args && args[1]) {
                this.$scope.gridColumns = args[1]
            }

            this.$scope.$broadcast(EventsNames.OPEN_BULK_EDIT_POPUP, bulkEditInitParams)
        }
    }

    private onSave(objectToSave: IOpObject): ng.IPromise<OpPackage> {
        const deferred = this.$q.defer<OpPackage>()
        const order: OpPackage = this.createOpPackageFromIOpObject(objectToSave, this.order)

        order.contentList = this.getOrderArticles()

        this.orderService
            .saveOrder(order)
            .then((savedOrder: OpPackage) => {
                this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedOrder)

                deferred.resolve(savedOrder)
            })
            .fail((error: any) => {

                deferred.reject(error)
            })

        return deferred.promise
    }

    private onBulkSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred = this.$q.defer<IOpObject>()

        return deferred.promise
    }

    //#endregion


    //#region Articles

    private getArticlesCustomSection(): CreateEditSection {
        return {
            name: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONTENT, this.moduleName),
            type: CommonCreateEdit.ReferenceObjectCustomParams,

            customSectionName: this.ADD_ORDER_CUSTOM_CREATE_EDIT_SECTION,
        }
    }

    private getOrderArticles(): OpDepositoryElement[] {
        if (this.ordersAddOrder != null) {
            return this.ordersAddOrder.getArticles()
        }

        return []
    }

    private initializeAddOrder(): void {
        this.addOrderOptions = {
            content: this.order != null ? this.order.contentList : null,
            readonly: this.order != null && this.order.idPackageStatus !== Enums.PackageStatus.NewOrder,

            onInitialized: (orderAdd: IAddOrder) => {
                this.ordersAddOrder = orderAdd
            },
        }
    }

    //#endregion


    //#region Setup

    private setEvents() {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_CREATE_EDIT_POPUP, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => this.onInit(args)
        )

        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_BULK_EDIT_POPUP, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => this.onInitBulk(args)
        )
    }

    private setOptions() {
        this.$scope.options = {
            localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.orderSaved,
            onClose: null,
            onSubmit: null,
            referenceType: this.referenceType,
            submitBulkEdit: null,
            succsessMessage: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, this.moduleName),
            title: '',
            type: null,

            onSave: (objectToSave: IOpObject) => this.onSave(objectToSave),
            onBulkSave: (objectToSave: IOpObject) => this.onBulkSave(objectToSave),
            onSectionChanged: (section: CreateEditSection) => {
                if (section != null && section.type === CommonCreateEdit.ReferenceObjectCustomParams && section.customSectionName === this.ADD_ORDER_CUSTOM_CREATE_EDIT_SECTION) {
                    this.initializeAddOrder()
                }
            }
        }
    }

    public createOpPackageFromIOpObject(opObject: IOpObject, sourceOrder: OpPackage = null): OpPackage {
        if (opObject == null) {
            return
        }

        const order: OpPackage = OpPackage.fromIOpObject(opObject)

        if (order.idPackage === 0) {
            order.creationDate = new Date()
        } else {
            if (sourceOrder != null) {
                order.creationDate = sourceOrder.creationDate
            }
        }

        return order
    }

    //#endregion
}